import React, {useEffect, useState} from 'react';
import {Autocomplete, CircularProgress, TextField} from '@mui/material';
import {getUsersByRole} from '../../../firebase/firestore/users';

export default function CollectorAssigneeSelect({
    value = null,
    onChange,
    disabled = false,
    label = 'Assignee (Collector)',
}) {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        getUsersByRole('collector')
            .then((users) => {
                if (cancelled) return;
                setOptions((users || []).map((u) => ({
                    id: u.id || u.userId,
                    displayName: u.displayName || u.name || u.email || u.id,
                    email: u.email,
                })));
            })
            .catch(() => { if (!cancelled) setOptions([]); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, []);

    const selected = value
        ? (options.find((o) => o.id === (value.id || value)) || {id: value.id || value, displayName: value.displayName || value.id || value})
        : null;

    return (
        <Autocomplete
            disabled={disabled}
            options={options}
            value={selected}
            onChange={(_, v) => onChange?.(v)}
            getOptionLabel={(o) => o?.displayName || o?.email || o?.id || ''}
            isOptionEqualToValue={(a, b) => a?.id === b?.id}
            loading={loading}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress color="inherit" size={16}/> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
        />
    );
}
